// extracted by mini-css-extract-plugin
export default {"selectContainer":"cef79m8t1","monthlyPrice":"cbnxxpl9i","monthlyPriceCurrency":"czyrwtuns","oldPrice":"ctyals94z","brHeight":"cdtp0t79w","discount":"cmwvfmviz"};